<template>
  <div>
    <p>
      The Geo Arc Protection feature will consider the satellite as unseen when
      <katex-element expression="\alpha" /> angle is below the threshold, to
      avoid interfering with higher-priority satellites.
      <br />
      The alpha angle is the minimum angle defined by the vector from the Earth
      point to the non-geostationary satellite and the vector from the Earth
      point to the point in the GEO arc that will minimise the
      <katex-element expression="\alpha" /> angle.
      <br />
      <v-img
        contain
        :src="require('../../../assets/images/tooltip-geo-arc-protection.png')"
        aspect-ratio="1"
      />
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipGeoArcProtection'
}
</script>
